/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Create_ButtonInputs */



/**
* | output |
* | --- |
* | "Create Project" |
*
* @param {New_Project_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_create_button = /** @type {((inputs?: New_Project_Create_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Create_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creer le projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを作成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar projeto")
	return /** @type {LocalizedString} */ ("Create Project")
});